import React from 'react';
import {
  BRAND_ICON, BRAND_MONO_SIZES, BRAND_SIZE, appBrandText, brandAssetName, brandAssetUrl,
} from '../../constants/brand';
import styles from './BrandMark.module.css';

/**
 * A NeoProf logo, shown as the image file `scripts/export-brand-assets.js` wrote
 * (docs/neoprof/brand/IDENTITY.md). The same file on every screen, PDF and
 * e-mail; the artwork itself lives in `BrandMarkArtwork`.
 * wordmark — "Ne" + Néo + suffix; 2-tone Néo at SM.
 * icon     — Néo in its tile; "Ne" + Néo at XL.
 */
const iconName = (size, mono) => {
  if (size === BRAND_SIZE.XL) return BRAND_ICON.XL;
  return mono ? BRAND_ICON.MONO : BRAND_ICON.FULL;
};

export default function BrandMark({
  app = 'PROF', variant = 'wordmark', tone = 'light', size = BRAND_SIZE.MD, className,
}) {
  const mono = BRAND_MONO_SIZES.includes(size);
  const name = variant === 'icon' ? iconName(size, mono) : brandAssetName(app, tone, mono);
  const classes = [styles[variant], styles[size], className].filter(Boolean).join(' ');
  return (
    <span className={classes} data-tone={tone} role="img" aria-label={appBrandText(app)}>
      <img className={styles.image} src={brandAssetUrl(name)} alt="" draggable="false" decoding="async" />
    </span>
  );
}
